module.exports = __webpack_public_path__ + "static/media/man.1a502a4b.png";